import React from 'react';
import { Card, CardBody } from '@nextui-org/react';

const TEAL = '#3fced1';

interface StatCardProps {
  label: string;
  value: string | number | null | undefined;
  icon?: React.ReactNode;
  sublabel?: string | null;
  accent?: boolean;
}

/**
 * Kleine Statistik-Kachel (dunkles Theme, Akzentfarbe #3fced1).
 */
const StatCard: React.FC<StatCardProps> = ({ label, value, icon, sublabel, accent = false }) => {
  const displayValue = value === null || value === undefined || value === '' ? '-' : String(value);

  return (
    <Card className="bg-zinc-900 border border-zinc-800">
      <CardBody className="p-4">
        <div className="flex items-center gap-2 mb-1">
          {icon && <span style={{ color: TEAL }}>{icon}</span>}
          <p className="text-xs uppercase tracking-wide text-gray-500 font-semibold">{label}</p>
        </div>
        <p
          className="text-2xl md:text-3xl font-bold tabular-nums"
          style={accent ? { color: TEAL } : undefined}
        >
          {displayValue}
        </p>
        {sublabel && <p className="text-xs text-gray-500 mt-1 line-clamp-1">{sublabel}</p>}
      </CardBody>
    </Card>
  );
};

export default StatCard;
